import { trackingEventOrganizations, } from "@buildwithflux/models";
export { trackingEventOrganizations };
/**
 * These are the valid actions for the trackingEventOrganizations event
 *
 * Use e.g. keyof typeof trackingActionsForOrganizations when typing against this
 */
export const trackingEventActionsForOrganizations = {
    create: "create",
    loadProfile: "loadProfile",
    loadProfileDocuments: "loadProfileDocuments",
    loadProfileMembers: "loadProfileMembers",
    loadProfileSettings: "loadProfileSettings",
    clickProfileNewProjectButton: "clickProfileNewProjectButton",
    addMembers: "addMembers",
    memberRemoved: "memberRemoved",
    memberUpdated: "memberUpdated",
    memberRoleChange: "memberRoleChange",
};
export function trackingEventParametersForOrganization(organization) {
    return {
        content_id: organization.uid,
        display_name: organization.displayName,
        organization_handle: organization.handle,
    };
}
/**
 * @todo make passing in the organizationPrivateMetadata non-optional once we have it decorating the membership in the frontend (WIP: Dom)
 */
export function traitsForOrganizationAsGroup(organization, organizationPrivateMetadata) {
    const traits = {
        // These are officially defined traits from upstream
        id: organization.uid,
        name: organization.handle,
        description: organization.bioContent
            ? `${organization.displayName}: ${organization.bioContent}`
            : organization.displayName,
        website: organization.websiteUrl,
        createdAt: new Date(organization.createdAt || Date.now()),
        // We explicitly don't include the email address due to a syncing issue we had with Segment -> Customer.io
        // This is probably also good in general, because organization.email is a public profile email address, not
        // necessarily one we should be sending emails to
        // email: organization.email,
        // These are officially defined traits that we don't really collect at the moment
        // employees (i.e. not just members, but an indication of the actual size of the organization, like you'd see asked on a signup form, 0-10, 10-100, 100-1000, sort of thing)
        // address
        // phone
        // industry
        // These are unofficial, custom traits (trying to match the name to user traits wherever possible)
        created_at: organization.createdAt, // This is what we unofficially use on other types, like user
        documents_count: organization.documentsCount,
        parts_count: organization.partsCount,
        follower_count: organization.follower_count,
        following_count: organization.following_count,
        activeProductUid: organization.activeProductUid, // camelCase, not snake_case, makes it the same as the user traits
        plan: organization.activeProductUid ? "paid" : "free",
        displayName: organization.displayName,
    };
    // TODO: for processing organization.customPictureKey, we need to use organizationStorageHelper/S3FileStorage, which isn't available in core yet
    if (organization.picture) {
        traits.avatar = organization.picture;
    }
    if (organizationPrivateMetadata) {
        if (organizationPrivateMetadata.editors?.count) {
            traits.editor_count = organizationPrivateMetadata.editors.count;
        }
    }
    return traits;
}
//# sourceMappingURL=organizations.js.map